import React from 'react'
import { CustomDialogContent } from '..'
import { createStyles, makeStyles, Typography, Theme } from '@material-ui/core'

interface IPrivacyProps {
  onClosePrivacyPage: () => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageContent: {
      lineHeight: 2,
      textAlign: 'justify',
      margin: theme.spacing(2, 0),
    },
  })
)

export const Privacy = ({ onClosePrivacyPage }: IPrivacyProps) => {
  const classes = useStyles()
  return (
    <CustomDialogContent title="Privacy Page" onCancel={onClosePrivacyPage}>
      <Typography variant="body1" className={classes.pageContent}>
        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
        Lorem Ipsum has been the industry standard dummy text ever since the 1500s,
        when an unknown printer took a galley of type and scrambled it to make a type
        specimen book.
      </Typography>

      <Typography variant="body1" className={classes.pageContent}>
        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
        Lorem Ipsum has been the industrys standard dummy text ever since the 1500s,
        when an unknown printer took a galley of type and scrambled it to make a type
        specimen book.
      </Typography>
    </CustomDialogContent>
  )
}
